import { render, staticRenderFns } from "./TopSlider.vue?vue&type=template&id=bfae254c&"
import script from "./TopSlider.vue?vue&type=script&lang=js&"
export * from "./TopSlider.vue?vue&type=script&lang=js&"
import style0 from "./TopSlider.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports